export default __webpack_public_path__ + "static/media/Danzaloon2019.45cab5ee.jpg";